import React from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import { arrayMove } from 'react-sortable-hoc';
import i18n from '../../../i18next';

import {
    loadPosSettings,
    loadMenus,
    resetMenus,
    loadCategories,
    loadProducts,
    loadQuestions,
    loadAnswers,
    reorderMenus,
    reorderCategories,
    reorderProducts,
    reorderQuestions,
    reorderAnswers,
    loadDependsOnQuestions,
    importMenu,
    exportMenu,
    publishAll,
    dispatchErrorMessage,
    activateMenu,
    isProductCopy,
    isProductEdit,
    resetProductCopy,
    resetQuestionCopy
} from '../../../actions';
import { capitalizeFirstLetter, isUserAllowedToSeePaymentType } from '../../../utils/CommonUtils';
import {
    MENU_ITEM_TYPE_MENU,
    MENU_ITEM_TYPE_CATEGORY,
    MENU_ITEM_TYPE_PRODUCT,
    MENU_ITEM_TYPE_QUESTION,
    MENU_ITEM_TYPE_ANSWER,
    MENU_ITEMS_TYPES_PLURALS,
    MENU_ITEM_SUB_QUESTION,
    MENU_ITEM_SUB_ANSWER,
    MENU_ITEM_TYPE_DEALS,
    FRONT_END_URL
} from '../../../utils/Constants';
import { loadTaxBands } from '../../../actions/restaurants/settings/restaurant/TaxBandsActions';
import MenuScreen from './MenuScreen';
import QuestionScreen from './QuestionScreen';
import CategoryScreen from './CategoryScreen';
import ProductScreen from './ProductScreen';
import AnswerScreen from './AnswerScreen';
import ImportMenuFromCSVScreen from './ImportMenuFromCSVScreen';
import MenuItemsColumn from './MenuItemsColumn';
import BaseMenuItemScreen from './BaseMenuItemScreen';
import CommonModal from '../../common/CommonModal';

class MenuConfigScreen extends BaseMenuItemScreen {
    constructor(props) {
        super(props);

        this.state = this.getInitialBaseState();
        this.state["menuScreenOpened"] = false;
        this.state["categoryScreenOpened"] = false;
        this.state["productScreenOpened"] = false;
        this.state["questionScreenOpened"] = false;
        this.state["answerScreenOpened"] = false;
        this.state["subQuestionScreenOpened"] = false;
        this.state["subAnswerScreenOpened"] = false;
        this.state["importMenuScreenOpened"] = false;
        this.state["isCommingSoonScreenOpened"] = false;
        this.state["index"] = -1;

        this.toggleScreens = this.toggleScreens.bind(this);
        this.reorderItems = this.reorderItems.bind(this);
        this.publishAll = this.publishAll.bind(this);
        this.importMenu = this.importMenu.bind(this);
        this.renderEditBtn = this.renderEditBtn.bind(this);
        this.toggleImportMenuFromCSVScreen = this.toggleImportMenuFromCSVScreen.bind(this);
        this.resetMenuStylesOnPublishOrImport = this.resetMenuStylesOnPublishOrImport.bind(this);
        this.toggleCommingSoon = this.toggleCommingSoon.bind(this);
        this.activateMenu = this.activateMenu.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        if (Object.keys(this.props.brand).length > 0) {
            if (this.props.brand.customerFrontEndTheme !== undefined) {
                localStorage.setItem('customerThemeType', this.props.brand.customerFrontEndTheme.type);
            }
        }

        this.props.loadPosSettings(id);
        this.props.loadMenus(id);
        this.props.loadTaxBands(id);
    }

    componentDidUpdate(prevProps) {
        const { isProductCopy, productCopy, isQuestionCopy, questionCopy } = this.props.productCopy;
        const restaurantId = this.props.match.params.id;
        let element = document.getElementsByClassName('menuItemsColumn');

        if (element.length > 5) {
            document.getElementById('masterCol').scrollBy({ bottom: 500, left: 500, behavior: 'smooth' });
        }

        if (isProductCopy) {
            this.toggleScreens(productCopy, false, 'product', restaurantId)
            this.props.resetProductCopy(false)
        }

        if(isQuestionCopy){
            this.toggleScreens(questionCopy , false, 'question', restaurantId)
            this.props.resetQuestionCopy(false);
        }
    }

    componentWillUnmount() {
        this.props.resetMenus();
    }

    isMenuuPOS() {
        if (this.props.posSettings !== undefined && this.props.posSettings !== null) {
            return this.props.posSettings.type.supportCsvFiles;
        }
    }

    toggleImportMenuFromCSVScreen() {
        this.setState({
            importMenuScreenOpened: !this.state.importMenuScreenOpened
        });
    }

    importMenu() {
        if (this.isMenuuPOS()) {
            this.toggleImportMenuFromCSVScreen();
        } else {
            const { id } = this.props.match.params;

            if (this.props.posSettings !== undefined && this.props.posSettings !== null) {
                this.props.importMenu(id, () => {
                    this.resetMenuStylesOnPublishOrImport();
                });
            } else {
                const message = i18n.t('screens:menuConfigScreen.menuPOSsettingMsg');
                this.props.dispatchErrorMessage(message);
            }
        }
    }

    activateMenu() {
        this.props.activateMenu(this.props.restaurant.id);
    }

    resetMenuStylesOnPublishOrImport() {
        this.setState({
            ...this.state,
            activeMenu: {},
            selectedMenu: {}
        });
    }

    publishAll() {
        const { id } = this.props.match.params;
        this.props.publishAll(id, () => {
            this.setState({
                ...this.state,
                activeMenu: {},
                selectedMenu: {}
            });
        });
    }

    toggleScreens(selectedItemData, saveOrPublish, screen, restaurantId) {
        if (!this.state[`${screen}ScreenOpened`]) {
            this.setState({
                [`${screen}ScreenOpened`]: !this.state[`${screen}ScreenOpened`],
                [`selected${capitalizeFirstLetter(screen)}`]: selectedItemData
            });

            if (selectedItemData.id === undefined) {
                if (screen === MENU_ITEM_TYPE_QUESTION) {
                    return this.props.loadDependsOnQuestions(selectedItemData, this.state.selectedProductDraftId);
                }

                if (screen === MENU_ITEM_SUB_QUESTION) {
                    return this.props.loadDependsOnQuestions(selectedItemData, this.state.selectedAnswerDraftId, true, restaurantId);
                }
            }

            let loadColumnItems =
                screen === MENU_ITEM_TYPE_QUESTION ? (this.loadColumnsData(selectedItemData, saveOrPublish, screen), this.props.loadDependsOnQuestions(selectedItemData, this.state.selectedProductDraftId))
                    : (screen === MENU_ITEM_TYPE_ANSWER ? (selectedItemData.mealDealProduct === true ? this.loadColumnsData(selectedItemData, false, screen, false, restaurantId) : this.selectCurrentAnswer(selectedItemData, saveOrPublish))
                        : (screen === MENU_ITEM_SUB_QUESTION ? (this.loadColumnsData(selectedItemData, saveOrPublish, screen), this.props.loadDependsOnQuestions(selectedItemData, this.state.selectedAnswerDraftId, true, restaurantId))
                            : (screen === MENU_ITEM_SUB_ANSWER ? this.selectCurrentSubAnswer(selectedItemData) : ((selectedItemData.id === undefined || selectedItemData.id === -1) ? {} : this.loadColumnsData(selectedItemData, saveOrPublish, screen)))));

            return loadColumnItems;
        } else if (saveOrPublish === true) {
            this.setState({
                [`${screen}ScreenOpened`]: !this.state[`${screen}ScreenOpened`],
                [`active${capitalizeFirstLetter(screen)}`]: {}
            });
        } else {
            this.setState({
                [`${screen}ScreenOpened`]: !this.state[`${screen}ScreenOpened`],
                [`selected${capitalizeFirstLetter(screen)}`]: {}
            });
        }
    }

    exportMenuCsv() {
        let restaurantId = this.props.restaurant.id;
        this.props.exportMenu(restaurantId);
    }

    toggleCommingSoon() {
        this.setState({
            isCommingSoonScreenOpened: !this.state.isCommingSoonScreenOpened
        });
    }

    reorderItems({ oldIndex, newIndex }, e) {
        const { activeMenu, activeCategory, activeProduct, activeQuestion, activeAnswer, activeSubQuestion } = this.state;
        const { match } = this.props;

        if (e.srcElement.id === undefined) return;

        const elementIdParts = e.srcElement.id.split('-');
        const itemsType = elementIdParts[0];
        let itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[itemsType];
        let itemsParameter = itemsTypePlural;
        let actionsParameter = itemsTypePlural;
        let parentId;

        switch (itemsType) {
            case MENU_ITEM_TYPE_MENU:
                parentId = match.params.id;
                break;
            case MENU_ITEM_TYPE_CATEGORY:
                parentId = activeMenu.id;
                break;
            case MENU_ITEM_TYPE_PRODUCT:
                parentId = activeCategory.id;
                break;
            case MENU_ITEM_TYPE_QUESTION:
                parentId = activeProduct.id;
                break;
            case MENU_ITEM_TYPE_ANSWER:
                parentId = activeQuestion.id;
                break;
            case MENU_ITEM_SUB_QUESTION:
                parentId = activeAnswer.id;
                itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[MENU_ITEM_TYPE_QUESTION];
                break;
            case MENU_ITEM_SUB_ANSWER:
                parentId = activeSubQuestion.id;
                itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[MENU_ITEM_TYPE_ANSWER];
                break;
        }

        this.doReorderItems(this.props[itemsParameter], oldIndex, newIndex, parentId, this.props[`reorder${capitalizeFirstLetter(itemsTypePlural)}`], actionsParameter);
    }

    doReorderItems(items, oldIndex, newIndex, parentId, action, actionsParameter) {
        let subItemsParam = (actionsParameter === MENU_ITEMS_TYPES_PLURALS[MENU_ITEM_SUB_QUESTION]) ||
            (actionsParameter === MENU_ITEMS_TYPES_PLURALS[MENU_ITEM_SUB_ANSWER]) ? true : false;

        if (items !== undefined) {
            const reorderedItems = arrayMove(items, oldIndex, newIndex);
            reorderedItems.forEach((item, index) => {
                item.priority = index + 1;
            });

            action(reorderedItems, parentId, subItemsParam);
        }

        return;
    }

    renderButtons() {
        const { flexEnd } = styles;
        const { posSettings, user } = this.props;

        if (!posSettings) return null;
        if (!posSettings.type) return null;

        let pixelPointRestaurant = false, isUserAdmin = false;
        let deliverectRestaurant = false;
        isUserAdmin = isUserAllowedToSeePaymentType(user);

        if (posSettings.type.id === 5 && posSettings.type.value === 'Par Pixelpoint') pixelPointRestaurant = true;
        if (posSettings.type.id === 7 && posSettings.type.value === 'Deliverect') deliverectRestaurant = true;

        return (
            <Row>
                <Col style={flexEnd}>
                    {!pixelPointRestaurant && isUserAdmin ? this.renderExportMenuButton() : null}
                    {!pixelPointRestaurant && !deliverectRestaurant && isUserAdmin ? this.renderImportMenuButton() : null}
                    {this.renderMenuPreviewButton()}
                    {this.renderPublishButton()}
                </Col>
            </Row>
        );
    }

    renderExportMenuButton() {

        return (
            <Button color="primary" style={{ marginRight: 10 }} onClick={this.exportMenuCsv.bind(this)}>
                <span style={{ position: 'relative', bottom: 2, marginRight: 4 }}>
                    <MaterialIcon icon="file_copy" color="#fff" size={18} />
                </span>
                <span>{i18n.t('screens:menuConfigScreen.export')}</span>
            </Button>
        );
    }

    renderPublishButton() {
        const { publishBtnTxt } = styles;

        return (
            <Button color="primary" onClick={this.publishAll}>
                <span className="menuIcons"><MaterialIcon icon="cloud_upload" color="#fff" size={19} /></span>
                <span style={publishBtnTxt} >{i18n.t('common:buttons.publish')}</span>
            </Button>
        );
    }

    openMenuPreview() {
        const restaurantId = this.props.match.params.id;
        const previewMode = true;
        let brandId = this.props.restaurant.chain.id;
        const customerThemeType = localStorage.getItem('customerThemeType');

        const url = `${FRONT_END_URL}/?previewMode=${previewMode}&restaurantId=${restaurantId}&brandId=${brandId}&customerThemeType=${customerThemeType}#/menu-screen`;
        window.open(url, '_blank');
    }

    renderMenuPreviewButton() {
        const { marginRight, publishBtnTxt } = styles;

        return (
            <Button style={marginRight} color="primary" onClick={() => this.openMenuPreview()}>
                <span className="menuIcons"><MaterialIcon icon="find_in_page" color="#fff" size={20} /></span>
                <span style={publishBtnTxt} >
                    {i18n.t('common:buttons.menupreview')}
                </span>
            </Button>
        );
    }

    renderImportMenuButton() {
        const { publishBtnTxt, marginRight } = styles;
        const buttonText = (this.props.posSettings.type.id === 11 && this.props.posSettings.type.value === 'Ordermark') ? i18n.t('screens:menuConfigScreen.activate') : i18n.t('screens:menuConfigScreen.import');
        const iconType = (this.props.posSettings.type.id === 11 && this.props.posSettings.type.value === 'Ordermark') ? 'power_settings_new' : 'cloud_download';
        const onClickFunction = (this.props.posSettings.type.id === 11 && this.props.posSettings.type.value === 'Ordermark') ? this.activateMenu : this.importMenu;

        return (
            <Button style={marginRight} color="primary" onClick={onClickFunction}>
                <span className="menuIcons"><MaterialIcon icon={iconType} color="#fff" size={19} /></span>
                <span style={publishBtnTxt}>{buttonText}</span>
            </Button>
        );
    }

    renderTitleRow(column, restaurantId) {
        const { addItemIcon } = styles;
        const { posSettings } = this.props;
        const posTypeId = posSettings && posSettings.type ? posSettings.type.id : null;
        
        return (
            posTypeId !== 7 ?
            <span style={addItemIcon} onClick={(item) => this.toggleScreens(item, false, column, restaurantId)}>
                <MaterialIcon icon="add_circle_outline" color="#0288D1" size={22} />
            </span> : null
        );
    }

    renderTitleParagraph(column) {
        const { titleStyle } = styles;
        const columnNameChange = (this.state.activeCategory.posId === "-123" && column === MENU_ITEM_TYPE_PRODUCT) ? MENU_ITEM_TYPE_DEALS : column;

        return (
            <p style={titleStyle}>{i18n.t(`screens:menuConfigScreen.${columnNameChange}`)}</p>
        );
    }

    toggleEditButton(item, column, restaurantId) {

        if(column === 'product') {
            this.props.isProductEdit(true)
        }

        this.toggleScreens(item, false, column, restaurantId)
    }


    renderEditBtn(item, column, restaurantId) {
        const { editStyle } = styles;

        return (
            <span
                color="link" style={editStyle}
                onClick={() => this.toggleEditButton(item, column, restaurantId)}>
                {i18n.t('common:sortableMenuItem.edit')}
            </span>
        );
    }

    renderMenuConfigColums() {
        const { containerColumn } = styles;
        const { posSettings, subQuestions, restaurant } = this.props;
        const { activeMenu, activeCategory, activeProduct, activeQuestion, activeAnswer, activeSubQuestion } = this.state;
        const restaurantId = this.props.match.params.id;
        const menuConfigColumns = [MENU_ITEM_TYPE_MENU, MENU_ITEM_TYPE_CATEGORY, MENU_ITEM_TYPE_PRODUCT, MENU_ITEM_TYPE_QUESTION, MENU_ITEM_TYPE_ANSWER];
        // const supportCsvFiles = !posSettings ? false : posSettings.type ? posSettings.type.supportCsvFiles : false;
        const supportCsvFiles = posSettings ? posSettings.type ? posSettings.type.supportCsvFiles : false : false; // INCOMING

        if (subQuestions.length > 0) {
            menuConfigColumns.push(MENU_ITEM_SUB_QUESTION, MENU_ITEM_SUB_ANSWER);
        }

        let isDeliverectPos = false;
        if (restaurant.posSettings) {
            isDeliverectPos = restaurant.posSettings.type.id === 7;
        }
        
        return (
            <Row>
                <Col style={containerColumn} id="masterCol">
                    {
                        menuConfigColumns.map((column, i) => {
                            const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];
                            let isRowHidden = false;
                            switch (column) {
                                case MENU_ITEM_TYPE_MENU:
                                    if (isDeliverectPos) {
                                        isRowHidden = true;
                                    }
                                    break;
                                case MENU_ITEM_TYPE_CATEGORY:
                                    if (!activeMenu.name || isDeliverectPos) {
                                        isRowHidden = true;
                                    }
                                    break;
                                case MENU_ITEM_TYPE_PRODUCT:
                                    if (!activeCategory.name || (activeCategory.name && !supportCsvFiles)) {
                                        isRowHidden = true;
                                    }
                                    if (activeCategory.name && isDeliverectPos) {
                                        isRowHidden = false;
                                    }
                                    break;
                                case MENU_ITEM_TYPE_QUESTION:
                                    if (!activeProduct.name || (isDeliverectPos && !this.state.activeProduct.mealDeal)) {
                                        isRowHidden = true;
                                    }
                                    break;
                                case MENU_ITEM_TYPE_ANSWER:
                                    if (!activeQuestion.name || (activeQuestion.name && !supportCsvFiles && (isDeliverectPos && !this.state.activeProduct.mealDeal))) {
                                        isRowHidden = true;
                                    }
                                    break;
                                case MENU_ITEM_SUB_QUESTION:
                                    isRowHidden = true;
                                    break;
                                case MENU_ITEM_SUB_ANSWER:
                                    isRowHidden = true;
                                    break;
                                default:
                                    false
                                    break;
                            }

                            let posIsNotConfigured = restaurant.posStatus === 'NOT_CONFIGURED';

                            return (
                                <MenuItemsColumn key={i}
                                    id={column}
                                    restaurantId={restaurantId}
                                    hiddenRow={isRowHidden}
                                    posNotConfigured={posIsNotConfigured}
                                    itemsTypePlural={itemsTypePlural}
                                    items={this.props[itemsTypePlural]}
                                    activeItem={this.state[`active${capitalizeFirstLetter(column)}`]}
                                    onSelect={(item) => this.loadColumnsData(item, false, column, false, restaurantId)}
                                    onReorder={this.reorderItems}
                                    renderTitleRow={this.renderTitleRow(column, restaurantId)}
                                    renderTitleParagraph={this.renderTitleParagraph(column)}
                                    renderActionComponent={this.renderEditBtn}
                                    sortDisabled={false}
                                    column={column}
                                    styles={styles}
                                />
                            );
                        })
                    }
                </Col>
            </Row>
        );
    }

    render() {
        const { containerStyle } = styles;
        const { id } = this.props.match.params;

        return (
            <Container fluid style={containerStyle}>
                {this.renderButtons()}
                <br />
                {this.renderMenuConfigColums()}
                {
                    this.state.menuScreenOpened ?
                        <MenuScreen
                            isOpen={this.state.menuScreenOpened}
                            handleBlur={(event) => { this.handleFocusOut(event) }}
                            onToggle={this.toggleScreens}
                            restaurantId={id}
                            menu={this.state.selectedMenu} /> : null
                }
                {
                    this.state.categoryScreenOpened ?
                        <CategoryScreen
                            isOpen={this.state.categoryScreenOpened}
                            onToggle={this.toggleScreens}
                            category={this.state.selectedCategory}
                            menuDraftId={this.state.selectedMenuDraftId}
                            restaurantId={id} /> : null
                }
                {
                    this.state.productScreenOpened ?
                        <ProductScreen
                            isOpen={this.state.productScreenOpened}
                            onToggle={this.toggleScreens}
                            restaurantId={id}
                            restaurant={this.props.restaurant}
                            product={this.state.selectedProduct}
                            categoryDraftId={this.state.selectedCategoryDraftId}
                        />
                        : null
                }
                {
                    this.state.questionScreenOpened ?
                        <QuestionScreen
                            itemType={MENU_ITEM_TYPE_QUESTION}
                            isOpen={this.state.questionScreenOpened}
                            onToggle={this.toggleScreens}
                            question={this.state.selectedQuestion}
                            productDraftId={this.state.selectedProductDraftId}
                            mealDealProduct={this.state.selectedProduct.mealDeal}
                            answers={this.props.answers}
                            restaurantId={id} /> : null

                }
                {
                    this.state.answerScreenOpened ?
                        <AnswerScreen
                            itemType={MENU_ITEM_TYPE_ANSWER}
                            isOpen={this.state.answerScreenOpened}
                            onToggle={this.toggleScreens}
                            restaurantId={id}
                            answer={this.state.selectedAnswer}
                            questionDraftId={this.state.selectedQuestionDraftId}
                            mealDealProduct={this.state.activeProduct.mealDeal}
                            answerGroups={this.state.activeQuestion.answerGroups}
                            activeMenu={this.state.selectedMenu}
                            activeCategory={this.state.selectedCategory}
                        />
                        : null
                }
                {
                    this.state.subQuestionScreenOpened ?
                        <QuestionScreen
                            itemType={MENU_ITEM_SUB_QUESTION}
                            isOpen={this.state.subQuestionScreenOpened}
                            onToggle={this.toggleScreens}
                            question={this.state.selectedSubQuestion}
                            productDraftId={this.state.selectedAnswerDraftId}
                            productDraftPosId={this.state.selectedAnswer.posId}
                            mealDealProduct={this.state.selectedProduct.mealDeal}
                            answers={this.props.subAnswers}
                            restaurantId={id} /> : null
                }
                {
                    this.state.subAnswerScreenOpened ?
                        <AnswerScreen
                            itemType={MENU_ITEM_SUB_ANSWER}
                            isOpen={this.state.subAnswerScreenOpened}
                            onToggle={this.toggleScreens}
                            answer={this.state.selectedSubAnswer}
                            questionDraftId={this.state.selectedSubQuestionDraftId}
                            mealDealProduct={this.state.activeProduct.mealDeal}
                            answerGroups={this.state.activeSubQuestion.answerGroups}
                            restaurantId={id} />
                        : null
                }
                <ImportMenuFromCSVScreen
                    isOpen={this.state.importMenuScreenOpened}
                    onToggle={this.toggleImportMenuFromCSVScreen}
                    restaurantId={this.props.match.params.id}
                    posSettings={this.props.posSettings}
                    resetMenuStylesOnPublishOrImport={this.resetMenuStylesOnPublishOrImport} />
                <CommonModal
                    useCase={'comingSoon'}
                    isOpen={this.state.isCommingSoonScreenOpened}
                    onToggle={this.toggleCommingSoon}
                >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <h4>{i18n.t('common:temporary.comingSoon')}</h4>
                    </div>
                </CommonModal>
            </Container >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menus: state.menus,
        categories: state.categories,
        products: state.products,
        questions: state.questions,
        answers: state.answers,
        subQuestions: state.subQuestions,
        subAnswers: state.subAnswers,
        posSettings: state.posSettings,
        brand: state.brand,
        restaurant: state.restaurant,
        user: state.user,
        productCopy: state.productCopy
    }
}

export default connect(mapStateToProps, {
    loadPosSettings, loadMenus, resetMenus, loadCategories, loadProducts, loadQuestions, loadAnswers,
    reorderMenus, reorderCategories, reorderProducts, reorderQuestions, reorderAnswers, importMenu,
    loadDependsOnQuestions, publishAll, loadTaxBands, dispatchErrorMessage, exportMenu, activateMenu, 
    isProductCopy, isProductEdit, resetProductCopy, resetQuestionCopy
})(MenuConfigScreen);

let styles = {
    containerStyle: {
        width: '100%',
        marginTop: 20,
        paddingLeft: 0,
        paddingRight: 0
    },
    containerColumn: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto'
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 15
    },
    addItemIcon: {
        cursor: 'pointer',
        width: 28
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    rowStyle: {
        width: '100%',
        height: 520,
        backgroundColor: '#F8F8F8',
        borderTop: '1px solid grey',
        marginRight: 0,
        marginLeft: 0,
        overflowY: 'auto'
    },
    titleColumn: {
        padding: '5px 5px 5px 0',
        flex: '0 0 20%',
        maxWidth: '20%'
    },
    titleColumnRow: {
        marginLeft: 0,
        marginRight: 0
    },
    titleColumnRowCol: {
        paddingLeft: 0
    },
    titleStyle: {
        float: 'left',
        marginBottom: 0,
        marginLeft: 0
    },
    iconsColumn: {
        paddingRight: 0
    },
    listGroupItem: {
        background: 'none',
        borderBottom: '1px solid #dee2e7'
    },
    fullWidthStyle: {
        width: '100%',
        height: 'fit-content'
    },
    editStyle: {
        color: '#0288d1',
        height: 0,
        cursor: 'pointer'
    },
    activeStyle: {
        backgroundColor: 'white',
        color: "#0288D1"
    },
    selectedItem: {
        color: "#0288D1",
        cursor: 'pointer'
    },
    pointerEvents: {
        pointerEvents: 'none'
    },
    activeIconStyle: {
        color: "#0288D1"
    },
    inactiveStyle: {
        color: "#cccccf",
        cursor: 'pointer'
    },
    inactiveStyleItalics: {
        fontStyle: "italic",
        color: "#cccccf",
        cursor: 'pointer'
    },
    selectedItemItalics: {
        fontStyle: "italic",
        color: "#0288D1",
        cursor: 'pointer'
    },
    activeNotPublished: {
        fontStyle: "italic",
        cursor: 'pointer'
    },
    buttonFloatRight: {
        float: 'right'
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    marginRight: {
        marginRight: 10
    },
    publishBtnTxt: {
        marginLeft: 6
    },
    importPadding: {
        paddingLeft: 2
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/MenuConfigScreen.js